module.exports = __webpack_public_path__ + "img/ff.3a68713f.png";